var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "booking-details__documents-row" }, [
    _c("label", { staticClass: "booking-details__checkbox" }, [
      _c("input", {
        attrs: { type: "checkbox" },
        domProps: { checked: _vm.selected_documents.includes(_vm.document.id) },
        on: { change: _vm.handleCheckboxChange }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "booking-details__checkbox-indicator" }),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "booking-details__checkbox-label line-clamp-1" },
        [_vm._v(_vm._s(_vm.document.name))]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "booking-details__documents-actions" }, [
      _vm.document.document_url.slice(-3).toLowerCase() === "pdf" ||
      _vm.document.pdf == 1
        ? _c(
            "a",
            {
              staticClass:
                "theme-btn theme-btn--small theme-btn--tertiary inline-flex gap-0 lg:gap-2",
              attrs: {
                "data-rel":
                  "lightcase:myCollection" + _vm.document.id + "desktop",
                title: _vm.document.name,
                href: _vm.document.document_url
              }
            },
            [
              _c("i", {
                staticClass: "icon-eye",
                staticStyle: { "font-size": "20px" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "hidden lg:block" }, [
                _vm._v(
                  _vm._s(
                    _vm.locales && _vm.locales.common && _vm.locales.common.view
                  )
                )
              ]),
              _vm._v(" "),
              _c("v-lightcase-holder", {
                attrs: {
                  "current-document": _vm.document,
                  "disable-rotate": true,
                  "image-src": _vm.document.document_url,
                  name: "box-" + _vm.document.id
                }
              })
            ],
            1
          )
        : _c(
            "a",
            {
              staticClass:
                "theme-btn theme-btn--small theme-btn--tertiary inline-flex gap-0 lg:gap-2",
              attrs: {
                href: "#box-" + _vm.document.id,
                "data-rel":
                  "lightcase:myCollection" + _vm.document.id + "desktop"
              }
            },
            [
              _c("i", {
                staticClass: "icon-eye",
                staticStyle: { "font-size": "20px" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "hidden lg:block" }, [
                _vm._v(
                  _vm._s(
                    _vm.locales && _vm.locales.common && _vm.locales.common.view
                  )
                )
              ]),
              _vm._v(" "),
              _c("v-lightcase-holder", {
                attrs: {
                  "current-document": _vm.document,
                  "disable-rotate": true,
                  "image-src": _vm.document.document_url,
                  name: "box-" + _vm.document.id
                }
              })
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "a",
        {
          ref: "toggleButton",
          class: [
            "theme-btn theme-btn--square--small theme-btn--gray lg:hidden",
            _vm.actionsPopup && "theme-btn--gray-active"
          ],
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.togglePopup.apply(null, arguments)
            }
          }
        },
        [
          _c("i", {
            staticClass: "icon-dots-horizontal",
            staticStyle: { "font-size": "20px" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "popup",
          class: [
            "booking-details__documents-actions-popup",
            _vm.actionsPopup &&
              "booking-details__documents-actions-popup--active"
          ]
        },
        [
          _c(
            "span",
            {
              staticClass: "theme-btn theme-btn--small theme-btn--destructive",
              on: { click: _vm.handleRemove }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.locales && _vm.locales.common && _vm.locales.common.remove
                )
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass:
                "theme-btn theme-btn--small theme-btn--theme whitespace-nowrap"
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales &&
                      _vm.locales.common &&
                      _vm.locales.common.upload_new
                  ) +
                  "\n        "
              ),
              _c("input", {
                staticStyle: { display: "none" },
                attrs: {
                  "data-id": _vm.document.id,
                  accept: "application/pdf, image/*",
                  name: "document[]",
                  type: "file"
                },
                on: {
                  change: _vm.handleFileChange,
                  file_updated: function($event) {
                    return this.$emit(
                      "update:imageSrc",
                      _vm.document.document_url
                    )
                  }
                }
              })
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e652e0f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e652e0f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/BookingDetailsDocument.vue
// module id = 738
// module chunks = 1